export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-amber-500 to-orange-600 rounded-lg">
                <i className="ri-car-line text-2xl text-white"></i>
              </div>
              <span className="text-xl font-bold font-['Space_Grotesk']">
                Ace's Auto Body
              </span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed mb-6">
              Your trusted auto body repair shop in Gardena, CA. Expert collision repair, painting, and restoration services since 2008.
            </p>
            <div className="flex items-center space-x-4">
              <a href="https://www.google.com/maps/place/16116+S+Main+St,+Gardena,+CA+90248" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-lg transition-all cursor-pointer">
                <i className="ri-map-pin-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-base font-bold mb-6 font-['Space_Grotesk']">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-sm text-gray-400 hover:text-amber-500 transition-colors cursor-pointer whitespace-nowrap">
                  Our Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('process')} className="text-sm text-gray-400 hover:text-amber-500 transition-colors cursor-pointer whitespace-nowrap">
                  How It Works
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('gallery')} className="text-sm text-gray-400 hover:text-amber-500 transition-colors cursor-pointer whitespace-nowrap">
                  Gallery
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('testimonials')} className="text-sm text-gray-400 hover:text-amber-500 transition-colors cursor-pointer whitespace-nowrap">
                  Testimonials
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-sm text-gray-400 hover:text-amber-500 transition-colors cursor-pointer whitespace-nowrap">
                  Contact Us
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold mb-6 font-['Space_Grotesk']">Services</h4>
            <ul className="space-y-3">
              <li className="text-sm text-gray-400">Collision Repair</li>
              <li className="text-sm text-gray-400">Auto Painting</li>
              <li className="text-sm text-gray-400">Dent Removal</li>
              <li className="text-sm text-gray-400">Bumper Repair</li>
              <li className="text-sm text-gray-400">Insurance Claims</li>
              <li className="text-sm text-gray-400">Auto Restoration</li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold mb-6 font-['Space_Grotesk']">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-amber-500 mt-1"></i>
                <span className="text-sm text-gray-400">
                  16116 S Main St<br />Gardena, CA 90248
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-phone-line text-amber-500"></i>
                <a href="tel:3105272838" className="text-sm text-gray-400 hover:text-amber-500 transition-colors">
                  (310) 527-2838
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-mail-line text-amber-500"></i>
                <a href="mailto:info@acescarshop.com" className="text-sm text-gray-400 hover:text-amber-500 transition-colors">
                  info@acescarshop.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © 2025 Ace's Auto Body Shop. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-amber-500 transition-colors whitespace-nowrap">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
